export default "__VITE_ASSET__DqoOIXQ7__"